import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper';
import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFPhone from '@/components/UI/svg/LandingPage/EFPhone';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFCoffeeMaker from '@/components/UI/svg/LandingPage/EFCoffeeMaker';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/');
const BUY_LINK: any = {
    sa: '',
    za: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
    // au: 'https://au.ecoflow.com/products/delta-2-portable-power-station',
};

export default function D2TSB(): JSX.Element {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const itemList = [
        {
            name: t('secF_Light'),
            times: `31 ${t('secF_hrs')}`,
            icon: <EFLight />,
        },
        {
            name: t('secF_WiFiRouter'),
            times: `31 ${t('secF_hrs')}`,
            icon: <EFWifiRouter />,
        },
        {
            name: t('secF_phone'),
            times: `89 ${t('secF_times')}`,
            icon: <EFPhone />,
        },
        {
            name: t('secF_laptop'),
            times: `16 ${t('secF_times')}`,
            icon: <EFLaptop />,
        },
        {
            name: t('secF_Refrigerator'),
            times: `7-14 ${t('secF_hrs')}`,
            icon: <EFRefrigerator />,
        },
        {
            name: t('secF_ElectricHeater'),
            times: `0.36 ${t('secF_hrs')}`,
            icon: <EFElectricHeater />,
        },
        {
            name: t('secF_Microwave'),
            times: `0.6 ${t('secF_hrs')}`,
            icon: <EFMicroware />,
        },
        {
            name: t('secF_ElectricKettle'),
            times: `0.5 ${t('secF_hrs')}`,
            icon: <EFElectricKettle />,
        },
        {
            name: t('secF_CoffeeMaker'),
            times: `0.8 ${t('secF_hrs')}`,
            icon: <EFCoffeeMaker />,
        },
        {
            name: t('secF_AirConditioner'),
            times: `1.8-3.6 ${t('secF_hrs')}`,
            icon: <EFAirConditioner />,
        },
    ];

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.landing_page_D2TSB',
            triggerHook: 1,
            offset: layoutH + 250,
        })
            .setClassToggle('.landing_page_D2TSB', 'show')
            .addTo(aniController);

        createScene({
            triggerElement: '.landing_page_D2TSB',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.landing_page_D2TSB_wrapper', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    return (
        <div className={`landing_page_D2TSB ${css.landing_page_D2TSB}`}>
            <div className="landing_page_D2TSB_wrapper">
                <div className="page_D2TSB_left">
                    <Swiper
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay, EffectFade]}
                        effect="fade"
                        className="swiperBox"
                        autoplay={{
                            delay: 5000,
                        }}
                        loop
                    >
                        <SwiperSlide>
                            <EFPic className="pageFImg" name={['bundle_delta2.webp', 'bundle_delta2.jpg']} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <EFPic
                                className="pageFImg scale"
                                name={
                                    locale === 'au'
                                        ? ['product/D2+D2EB+TS.webp', 'product/D2+D2EB+TS.png']
                                        : locale === 'za'
                                        ? ['product/bundle_delta2_ts_za.webp', 'product/bundle_delta2_ts_za.png']
                                        : ['product/bundle_delta2_ts.webp', 'product/bundle_delta2_ts.png']
                                }
                            />
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="page_D2TSB_right">
                    <div className="page_D2TSB_rightBox">
                        <div className="leftContentBox_1">
                            <div className="leftInnerBox">
                                <div className="secF_powerList">{t('secF_powerList')}</div>
                                <div className="leftListBox">
                                    {itemList.map((item: any, index: number) => (
                                        <div key={index} className="leftListItem">
                                            <div className="itemImg">{item.icon}</div>
                                            <div>
                                                <div className="itemName">{item.name}</div>
                                                <div className="itemTimes">{item.times}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="leftContentBox_2">
                            <div>
                                <div className="secF_title">{t('ts_bundle_delta2_1')}</div>
                                <div className="secF_pro_name">{t('ts_bundle_delta2_2')}</div>
                                <div className="secF_pro_paramBox">
                                    {t.rich('ts_bundle_delta2_3', {
                                        p: (text: string) => <p className="secF_pro_param">{`- ${text}`}</p>,
                                    })}
                                </div>
                                <div className="secF_pro_desc">{t('ts_bundle_delta2_4')}</div>
                                {BUY_LINK[locale] && (
                                    <Link
                                        className="secFButton btnHover"
                                        href={BUY_LINK[locale]}
                                        target="blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: t('ts_bundle_delta2_1'),
                                            position: `Solution Page_${t('ts_bundle_delta2_2')}`,
                                        }}
                                    >
                                        {locale === 'au' ? t('learn_more') : t('secF_buyNow')}
                                    </Link>
                                )}
                                <div className="secF_tip">{t('ts_bundle_delta2_tip')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
